import { createFileRoute, redirect } from '@tanstack/react-router';

/* «Invia comunicazioni» è diventata una circolare il 26-10-2026 (task 2055): una comunicazione è
   una circolare pubblicata subito. Tiene vivi i vecchi link. */
export const Route = createFileRoute('/_app/admin/send-communications')({
  beforeLoad: () => { throw redirect({ to: '/circulars/register', search: { new: true }, replace: true }); },
});
